import { RoutesPaths, SubRouteType } from 'routes/Routes.types';
import { useCheckPermission } from 'hooks/useCheckPermission';
import EventDetails from 'pages/private/Events/components/EventDetails';
import EventList from 'pages/private/Events/components/EventList';

const useGetEventSubRoutesData = () => {
  const eventSubRoutes: SubRouteType[] = [
    {
      component: EventList,
      path: RoutesPaths.EVENTS,
      show: false,
      showByPermissions: useCheckPermission(['EVENT_VIEW']),
    },
    {
      component: EventDetails,
      path: RoutesPaths.EVENTS_BY_ID,
      show: false,
      showByPermissions: useCheckPermission(['EVENT_VIEW']),
    },
    {
      component: EventDetails,
      path: RoutesPaths.EVENTS_BY_ID_INPUTS_OUTPUTS,
      show: false,
      showByPermissions: useCheckPermission(['EVENT_VIEW']),
    },
  ];
  return { eventSubRoutes };
};

export default useGetEventSubRoutesData;
